import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        return (
            <div>
                <h3><center><u>Plucking And Sundry Labour Attendence Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division == undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>Employee Category: </b> {searchData.empType == 0 ? "All Employee Types" : searchData.empType == 2 ? "Labour" : "Sundry"}</div>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>EPF No</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Picture</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Job Type</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>NIC</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>In Date & Time</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Out Date & Time</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData.map((row, i) => (
                                <TableRow key={i}>
                                    <TableCell component="th" scope="row" align="center"> {row.epfNo}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.convertedEmployeeBiometricData && (<img src={row.convertedEmployeeBiometricData} width="75" height="75"></img>)}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.firstName}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.designationName}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.division}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {row.nic}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {moment(row.startTime).format('YYYY-MMM-DD h:mm:ss A')}</TableCell>
                                    <TableCell component="th" scope="row" align="center"> {moment(row.endTime).format('YYYY-MMM-DD h:mm:ss A')}</TableCell>

                                </TableRow>
                            )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}